var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeighborhoodconnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 512",
    style: {
      enableBackground: "new 0 0 384 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#68995D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 191.5,
    cy: 178.5,
    rx: 146.7,
    ry: 140.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.5,512c0,0,192-208,192-320c0-106-86-192-192-192s-192,86-192,192C-0.5,304,191.5,512,191.5,512z  M189.5,45.6c71.5,0,129.4,57.9,129.4,129.4S261,304.4,189.5,304.4S60.1,246.4,60.1,175S118.1,45.6,189.5,45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293,165.5c0,6.3-5.3,11.3-11.3,11.3h-11.3l0.2,56.5c0,1-0.1,1.9-0.2,2.9v5.7c0,7.8-6.3,14.1-14.1,14.1h-5.6 c-0.4,0-0.8,0-1.2,0c-0.5,0-1,0-1.5,0l-11.5,0h-8.5c-7.8,0-14.1-6.3-14.1-14.1v-8.5v-22.6c0-6.2-5-11.3-11.3-11.3h-22.6 c-6.2,0-11.3,5-11.3,11.3v22.6v8.5c0,7.8-6.3,14.1-14.1,14.1h-8.5h-11.3c-0.5,0-1.1,0-1.6-0.1c-0.4,0-0.8,0.1-1.3,0.1h-5.6 c-7.8,0-14.1-6.3-14.1-14.1v-39.5c0-0.3,0-0.7,0-1v-24.6h-11.3c-6.3,0-11.3-4.9-11.3-11.3c0-3.2,1.1-6,3.5-8.5l90.4-78.8 c2.5-2.5,5.3-2.8,7.8-2.8s5.3,0.7,7.4,2.5l90.1,79.2C291.9,159.5,293.3,162.3,293,165.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeighborhoodconnection);
export default __webpack_public_path__ + "static/media/neighborhoodconnection.9787dd4b8c741919b519eacee2ca1238.svg";
export { ForwardRef as ReactComponent };